import React, { Component } from "react";
import ReactDOM from 'react-dom';
// eslint-disable-next-line
import router from "umi/router";
import { message, Popconfirm, Tooltip } from "antd";
import { connect } from "dva";
import moment from "moment";
import { stringify } from "qs";
import store from "store2";
import { ENV, readObj } from "@/services/utils";
import { getComposeUrl } from '@/utils/common';
import ListPage from "../../../../components/ListPage";
import ListSearch from "../Components/ListSearch";
import styles from "./index.less";
import OperateDropdown from "../../../../components/OperateDropdown";
import Container from "../../../../components/Container";
import LockedWarn from '../Components/LockedModal/LockedWarn';
import LockedModal from '../Components/LockedModal';
import PwdModal from '../Components/PwdModal';
import { SALARY_CAT_LOCKED } from '../constants';

const { ListTable, ListCreate } = ListPage;

@connect(({ manage, user, loading }) => {
  return {
    loading: loading.effects["manage/fetchList"],
    orgType: user.currentUser.orgType,
    ...manage
  };
})
class List extends Component {
  rootEle = null;
  rootSlaveEle = null;

  componentDidMount() {
    this.handleFetchList(1, 10, true, true);
    this.rootEle = document.getElementById('root');
    this.rootSlaveEle = document.getElementById('root-slave');
  }

  switchSendState = sendState => {
    switch (sendState) {
      case 1:
        return {
          status: "草稿",
          sendStateCls: "yellow",
          action: this.renderDraftAction
        };
      case 2:
        return {
          status: "待发布",
          sendStateCls: "blue",
          action: this.renderNoReleasedAction
        };
      case 3:
        return {
          status: "发布中",
          sendStateCls: "yellow",
          action: this.renderReleasing
        };
      case 4:
        return {
          status: "发布成功",
          sendStateCls: "green",
          action: this.renderReleaseAction
        };
      case 5:
        return {
          status: "发布失败",
          sendStateCls: "red",
          action: this.renderDraftAction
        };
      case 6:
        return {
          status: "已撤回",
          sendStateCls: "grey",
          action: this.renderDraftAction
        };
    }
  };

  handleError = err => {
    message.error(err);
  };

  handleGoToDetail = (id, data) => {
    const { sendStatus } = data;
    router.push(
      getComposeUrl(
        `/wages/management/detail?id=${id}&sendStatus=${sendStatus}`
      )
    );
  };

  // 去新建页或者编辑页
  handleGoToCreateOrEdit = (type = "create", id = "", sendStatus = "") => {
    const { dispatch } = this.props;
    dispatch({
      type: "salaryCreate/reset"
    });
    if (type === "create") {
      router.push(getComposeUrl(`/wages/create`));
    } else {
      router.push(
        getComposeUrl(
          `/wages/management/edit?id=${id}&type=${type}&sendStatus=${sendStatus}`
        )
      );
    }
  };

  // 分页器点击
  handlePaginationChange = (page, pageSize) => {
    const { queries } = this.props;
    this.handleQuery({
      page,
      pageSize,
      queries
    });
  };

  // 搜索列表
  handleFetchList = (page, pageSize, reFresh = true, first = false) => {
    const { dispatch } = this.props;

    dispatch({
      type: "manage/fetchList",
      payload: {
        page,
        pageSize,
        reFresh,
        first
      }
    });
  };

  // 查询列表数据
  handleQuery = ({ queries = {}, page = 1, pageSize = 10 }) => {
    const { dispatch } = this.props;

    dispatch({
      type: "manage/save",
      payload: {
        page,
        pageSize,
        queries
      }
    });

    dispatch({
      type: "manage/fetchSearch",
      payload: {
        page,
        pageSize,
        ...queries
      }
    });
  };

  // 删除
  handleDel = id => {
    const { dispatch } = this.props;
    dispatch({
      type: "manage/fetchDel",
      payload: {
        id
      }
    });
  };

  // 撤回、提醒、立即发布、补发
  handleFetchRequest = ({ id, fetchType }) => {
    const { dispatch } = this.props;
    dispatch({
      type: "manage/fetchRequest",
      payload: {
        id,
        fetchType // 接口类型
      }
    });
  };

  // 关闭密码超过次数锁定问题提示
  handleCloseLock = () => {
    this.handleSave({ lockedVisible: false });
  };

  // 取消输入密码
  handleCancelPwd = () => {
    this.handleSave({ pwdVisible: false });
  };

  // 确认提交密码
  handleSendPwd = password => {
    const { dispatch } = this.props;
    dispatch({
      type: 'manage/verifyPassword',
      payload: {
        password,
        type: 'list',
      },
      callback: this.handleCallBack
    });
  };

  handleSave = payload => {
    const { dispatch } = this.props;
    dispatch({
      type: 'manage/save',
      payload
    });
  };

  // 删除
  renderDelBtn = id => {
    return (
      <Popconfirm
        title="确认删除?"
        okText="确认"
        cancelText="取消"
        className="del"
        onConfirm={() => this.handleDel(id)}
      >
        <a>删除</a>
      </Popconfirm>
    );
  };

  // 撤回
  renderRecallInformBtn = id => {
    return (
      <Popconfirm
        overlayStyle={{ zIndex: 1051 }}
        title={
          <div>
            撤回后已通知的用户将不可继续查看该工资条
            <br />
            是否确认撤回？
          </div>
        }
        okText="确认"
        cancelText="取消"
        className="del"
        onConfirm={() => this.handleFetchRequest({ id, fetchType: "recall" })}
      >
        <a>撤回</a>
      </Popconfirm>
    );
  };

  renderReleasing = () => {
    return "-";
  };

  // 待发布 状态下 操作
  renderNoReleasedAction = ({ id }) => {
    const data = [
      {
        text: (
          <a onClick={() => this.handleGoToCreateOrEdit("edit", id)}>编辑</a>
        )
      },
      {
        text: this.renderDelBtn(id)
      },
      {
        text: (
          <a
            onClick={() =>
              this.handleFetchRequest({ id, fetchType: "publish" })
            }
          >
            发布
          </a>
        )
      }
    ];
    return <OperateDropdown data={data} />;
  };

  // 发布成功 状态下 操作
  renderReleaseAction = ({ id, notReadCount, sendStatus }) => {
    const data = [
      {
        text: (
          <a
            onClick={() => this.handleGoToCreateOrEdit("edit", id, sendStatus)}
          >
            编辑
          </a>
        )
      },
      {
        text: (
          <a
            disabled={notReadCount === 0}
            onClick={() => this.handleFetchRequest({ id, fetchType: "remind" })}
          >
            提醒
          </a>
        )
      },
      {
        text: this.renderRecallInformBtn(id)
      }
    ];
    return <OperateDropdown data={data} />;
  };

  // 已撤回 状态下 操作
  renderRevokeAction = ({ id }) => {
    const data = [
      {
        text: (
          <a onClick={() => this.handleGoToCreateOrEdit("edit", id)}>编辑</a>
        )
      },
      {
        text: this.renderDelBtn(id)
      }
    ];
    return <OperateDropdown data={data} />;
  };

  // 草稿 状态下 操作
  renderDraftAction = ({ id, sendState }) => {
    const data = [
      {
        text: (
          <a onClick={() => this.handleGoToCreateOrEdit("edit", id)}>编辑</a>
        )
      },
      {
        text: this.renderDelBtn(id, sendState)
      }
    ];
    return <OperateDropdown data={data} />;
  };

  renderAction = (_, record) => {
    const { sendStatus } = record;
    return this.switchSendState(sendStatus).action(record);
  };

  handleGoReadDetail = (readId, id) => {
    const { orgId } = store.session("currentUser") || {};
    const { countId, appId } = readObj.wages[ENV];
    if (readId > 0) {
      router.push(getComposeUrl(`/wages/management/readDetail?id=${readId}`));
      return null;
    }
    router.push(
      `${getComposeUrl("/newReadDetail")}?${stringify({
        infoId: id,
        countId,
        appId,
        parentId: orgId
      })}`
    );
  };

  render() {
    const {
      pageInfo,
      list,
      spinProps,
      statusList = [],
      salaryCatAuth,
      lockedVisible,
      pwdVisible,
    } = this.props;

    const columns = [
      {
        title: "工资表名称",
        dataIndex: "title",
        key: "title",
        width: 200,
        fixed: "left",
        render: title => (
          <Tooltip placement="top" title={title}>
            <div className="title">{title}</div>
          </Tooltip>
        )
      },
      {
        title: "发放月份",
        dataIndex: "salaryMonth",
        key: "salaryMonth",
        width: 100,
        render: salaryMonth => salaryMonth || '-'
      },
      {
        title: "发布者",
        key: "senderName",
        dataIndex: "senderName",
        render: text => {
          if (!text) {
            return "-";
          }
          if (text.length <= 8) {
            return <span>{text}</span>;
          }
          return (
            <Tooltip placement="top" title={text}>
              <span>{text.substring(0, 8)}...</span>
            </Tooltip>
          );
        }
      },
      {
        title: "发布时间",
        dataIndex: "sendTime",
        key: "sendTime",
        render: (sendTime, record) => {
          const { sendStatus } = record;
          if (sendStatus === 1) {
            return "-";
          }

          return sendTime ? moment(sendTime).format("YYYY.MM.DD HH:mm") : "-";
        }
      },
      {
        title: "状态",
        key: "sendStatus",
        dataIndex: "sendStatus",
        render: sendState => {
          const { status, sendStateCls } = this.switchSendState(sendState);
          return (
            <span className={`send_state ${sendStateCls}`}>{status} </span>
          );
        }
      },

      {
        title: "发布人数",
        key: "sendNumber",
        dataIndex: "sendNumber",
        render: text => {
          return text || "-";
        }
      },
      {
        title: "未阅/已阅",
        key: "readCount",
        dataIndex: "readCount",
        render: (text, record) => {
          const {
            sendStatus = "",
            counted = 0,
            noCounted = 0,
            id,
            readId
          } = record;
          // "0": "初稿",
          // "1": "草稿",
          // "2": "待发布",
          // "3": "发布中",
          // "4": "发布成功",
          // "5": "发布失败",
          // "6": "撤回"
          if (sendStatus === 1 || sendStatus === 3) {
            return "-";
          }
          return (
            <a
              onClick={e => {
                e.stopPropagation();
                this.handleGoReadDetail(readId, id);
              }}
            >
              {noCounted || 0}/{counted || 0}
            </a>
          );
        }
      },
      {
        title: "操作",
        key: "action",
        fixed: "right",
        width: 160,
        render: this.renderAction
      }
    ];

    const pageProps = {
      spinProps,
      className: styles.root
    };

    const searchProps = {
      type: "outbox",
      statusList,
      handleQuery: this.handleQuery
    };

    const createBtn = {
      btnText: "新建工资条",
      onCreate: this.handleGoToCreateOrEdit
    };

    const tableProps = {
      pageInfo,
      columns,
      list,
      rowKey: "id",
      onItemClick: this.handleGoToDetail,
      onPageChange: this.handlePaginationChange
    };

    return (
      <Container breStates isSplitBar>
        {!salaryCatAuth ? (
          <ListPage {...pageProps}>
            <ListSearch {...searchProps} />
            <div className="divider" />
            <ListCreate {...createBtn} />
            <ListTable {...tableProps} />
          </ListPage>
        ) : (
          <>
            <div className={styles['hide-cover']} />
            {salaryCatAuth === SALARY_CAT_LOCKED && (this.rootEle || this.rootSlaveEle)
              && ReactDOM.createPortal(<LockedWarn />, (this.rootEle || this.rootSlaveEle))}
            <LockedModal visible={lockedVisible} handleClose={this.handleCloseLock} />
            <PwdModal
              visible={pwdVisible}
              onCancel={this.handleCancelPwd}
              onOk={this.handleSendPwd}
            />
          </>
        )}
      </Container>
    );
  }
}

export default List;
